module.exports = __webpack_public_path__ + "static/media/sabina_namastee.85a76845.gif";